import React, { useRef } from "react";
import DraftEditor from "../DraftEditor";
import VariableSelectBox from "../VariableSelectBox";
import { VARIABLE_HELP_TEXT } from "../../constants/constants";

const FollowUp = (props) => {
    const data = props;
    const textareaRef = useRef(null);
    const onBlur = (key,index) => {
        return (e) => {
            const updatedErrors = (data.errors).map((row,i)=>{
                if(index === i && e.target.value == '0'){
                    row[key] = 'The value must be greater than 0';
                } else if(index === i && !(e.target.value).length && e.target.value != '0'){
                    row[key] = 'Field can not blank';
                }
                return row;
            });        
            data.handleFieldErrors([...updatedErrors]);
        }        
    }
    const onFocus = (key,index) => {
        return (e) => {
            const updatedErrors = (data.errors).map((row,i)=>{
                if(index === i){
                    row[key] = '';
                }
                return row;
            });        
            data.handleFieldErrors([...updatedErrors]);
        } 
    }
    const onEditorBlur = (key,index) => {
        return (e) => {
            const updatedErrors = (data.errors).map((row,i)=>{
                if(index === i && ((e.target).innerText).length <= 1){
                    row[key] = 'Follow up message can not blank';
                }
                return row;
            });        
            data.handleFieldErrors([...updatedErrors]);
        }  
    }
    const onEditorFocus = (key,index) => {
        return (e) => {
            const updatedErrors = (data.errors).map((row,i)=>{
                if(index === i){
                    row[key] = '';
                }
                return row;
            });        
            data.handleFieldErrors([...updatedErrors]);
        } 
    }

    const convertHtmlToPlainText = (html) => {
        const element = document.createElement('div');
        element.innerHTML = html;
        return element.innerText || element.textContent;
    };

    const openModelWindow = (stepIndex) => {
        data.setSelectedStepIndex(stepIndex);
        data.setToggleSendTestModelWindow(!data.toggleSendTestModelWindow);
    }

    const handleInsertAtCursor = (item) => {
        const textarea = textareaRef.current;
        
       let text = convertHtmlToPlainText(data.step.body);
       //let text = campaignSteps[0].body;

        // Get current cursor position
        const cursorPosition = textarea.selectionStart;
    
        // Insert the item at the cursor position
        const newText = text.slice(0, cursorPosition) + item + text.slice(cursorPosition);
    
        // Update the text and set the cursor position back after inserting
        data.step.body = newText;
        // After inserting, set the cursor back to where it was
        setTimeout(() => {
          textarea.selectionStart = cursorPosition + item.length;
          textarea.selectionEnd = cursorPosition + item.length;
          textarea.focus();
        }, 0);
      };

    return(<>
        <div className="follow-up-fields">
            <div className="top-row">
                <div className="wait-time">
                    <span className="label-xs">Wait X days</span>
                    <input 
                        required
                        type="text" 
                        value={data.step.minimum_delay_after_last_send}
                        onChange={data.handleStepChange(data.step,'minimum_delay_after_last_send')}
                        onFocus={onFocus('minimumDelay',data.index)}
                        onBlur={onBlur('minimumDelay',data.index)}
                    />
                    {(data.errors).length ? <span className="validation-error">{typeof data.errors[data.index] !== 'undefined' ? data.errors[data.index].minimumDelay:''}</span>:''}
                </div>
                <div className="delete-action" onClick={data.handleRemoveError(data.index)}>
                    <span className="delete-icon" onClick={data.handleDeleteStep(data.step)}>
                    <i className='bx bx-trash'></i>
                    </span>
                </div>
            </div>
            <div className="test-link">
                <button 
                    type="button" 
                    onClick={()=>{openModelWindow(data.index)}}
                    ><i className='bx bx-paper-plane'></i> Send Test</button>
            </div>
            <div className="field-wrap">
                <label className="label-xs">Reply chain</label>
                <input 
                    type="text"
                    readOnly
                    value={data.step.subject}
                    onChange={data.handleStepChange(data.step,'subject')}
                />
            </div>
            <div className="text-area">
            {props.messageMimeType === 'text/html' ? <DraftEditor
                emailVariables={true}
                className={'follow-up-editor'}
                onContentChange={data.handleStepChange(data.step,'body')}
                defaultContent={data.step.body}
                onBlur={onEditorBlur('body', data.index)}
                onFocus={onEditorFocus('body',data.index)}
            /> : <>
                <div className="btn-group">
                    <VariableSelectBox
                        handleInsertAtCursor = { handleInsertAtCursor }
                    />
                    <div className="variable-helpbox">
                        <span><i className='bx bx-question-mark'></i></span>
                        <div className="helpbox-details">
                            <p>{VARIABLE_HELP_TEXT}</p>
                        </div>
                    </div>
                </div>
                <textarea 
                    ref={textareaRef}
                    className={'follow-up-editor'} 
                    value={convertHtmlToPlainText(data.step.body)}
                    onInput={data.handleStepChange(data.step,'body')}
                    onBlur={onBlur('body', data.index)}
                    onFocus={onFocus('body',data.index)}
                />
            </>}
            {(data.errors).length ? <span className="validation-error">{typeof data.errors[data.index] !== 'undefined' ? data.errors[data.index].body:''}</span>:''}
            </div>
        </div>
    </>);
}

export default FollowUp;